import { CommonModule } from '@angular/common';
import { Component, inject } from "@angular/core";
import { RouterModule } from '@angular/router';

import { AuthService } from "@services/auth.service";
import { ToastOverlayManager } from '@services/toast-overlay-manager.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class AppComponent {
  private readonly _bootstrapAuth = inject(AuthService);
  private toastOverlay = inject(ToastOverlayManager);
  title = "app";
}
